import { useMutation } from "@tanstack/react-query";

import http from "../../../http";
import { IAxisErrorResponse } from "../../../interfaces";

const resendActivationEmail = async (email: string) => {
  await http.post(
    `${process.env.REACT_APP_USER_SERVICE_API_URL}/api/user/resendActivationLink`,
    {},
    {
      params: {
        email,
      },
    }
  );
};

const useResendActivationEmail = () =>
  useMutation<void, IAxisErrorResponse, string>({
    mutationKey: ["resendActivationEmail"],
    mutationFn: resendActivationEmail,
  });

export default useResendActivationEmail;
